/**
 * The Ankiety tab's two controls, standing in the tab strip's own row.
 *
 * KANON `Raporty` draws them there — flush right of the three tabs, under the heading — rather than
 * over the column they narrow. So they are the strip's `trailing` node, they are rendered only while
 * that tab is selected (a control that narrows a list the trainer is not looking at is a control
 * that appears to do nothing), and the value they narrow by is owned by the screen.
 */

import { useTranslation } from 'react-i18next';

import { SearchField } from '~/shared/ui/SearchField';

import { useSurveyTools } from '../lib/useSurveyTools';
import type { SurveyFacets } from '../model/surveyFilters';
import { SurveyFilterMenu } from './SurveyFilterMenu';
import styles from './ReportsScreen.module.css';

interface SurveyToolsProps {
  readonly facets: SurveyFacets;
  readonly onChange: (facets: SurveyFacets) => void;
}

export function SurveyTools({ facets, onChange }: SurveyToolsProps) {
  const { t } = useTranslation();
  const tools = useSurveyTools();

  return (
    <div className={styles.tabTools}>
      <SearchField
        className={styles.search}
        value={facets.query}
        onChange={(query) => {
          onChange({ ...facets, query });
        }}
        label={t('web:reports.surveys.searchLabel')}
        placeholder={t('web:reports.surveys.searchPlaceholder')}
        clearLabel={t('web:reports.surveys.searchClear')}
        disabled={tools.disabled}
        size="compact"
      />
      <SurveyFilterMenu
        facets={facets}
        onChange={onChange}
        clients={tools.clients}
        disabled={tools.disabled}
      />
    </div>
  );
}
